var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { FileUploadSection } from "@frameworks/shared-library/components/fileupload/fileUploadSection";
import GenericSidebar from "../../../../../../../shared-library/components/GenericSidebar";
import EdModal from "@frameworks/web/components/generic/edModal";
import DetailMandatesPop from "./DetailMandatesPop";
import MandatePopup from "./MandatePopup";
import di from "../../../di/serviceLocator";
import { useSelector } from "react-redux";
import { accountDetails } from "@salesdi";
import downloadimg from "@frameworks/shared-library/assets/images/SalesJourney/download-img.svg";
import SalesToasts from "@frameworks/shared-library/components/Toasts";
import loaderGIF from "@frameworks/shared-library/assets/images/Reports/loaderGIF.gif";
var ConsentMandate = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
    var _z = __read(React.useState(props.smtfDetails), 2), consentData = _z[0], setConsentData = _z[1];
    var _0 = __read(React.useState(false), 2), upload = _0[0], setUpload = _0[1];
    var _1 = __read(React.useState(false), 2), mandate = _1[0], setMandate = _1[1];
    var _2 = __read(React.useState(false), 2), detailMandate = _2[0], setdetailMandate = _2[1];
    var _3 = __read(useState(false), 2), showFnoDetailsSuccess = _3[0], setShowFnoDetailsSuccess = _3[1];
    var _4 = __read(React.useState(false), 2), showErrorMsg = _4[0], setShowErrorMsg = _4[1];
    var _5 = __read(React.useState(false), 2), showFnoLoader = _5[0], setShowFnoLoader = _5[1];
    var _6 = __read(useState(""), 2), showFnoDetailsSuccessMsg = _6[0], setShowFnoDetailsSuccessMsg = _6[1];
    var _7 = __read(useState(false), 2), resetFileUpload = _7[0], setResetFileUpload = _7[1];
    var _8 = __read(React.useState(false), 2), bseRequest = _8[0], setBseRequest = _8[1];
    var _9 = __read(React.useState(""), 2), bseRequestData = _9[0], setBseRequestData = _9[1];
    var _10 = __read(React.useState(), 2), fileBase64 = _10[0], setFileBase64 = _10[1];
    var _11 = __read(React.useState(), 2), sampleFile = _11[0], setSampleFile = _11[1];
    var selectedAccount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var userData = useSelector(function (state) {
        return state.Profile.ProfileDetails.reducersData.data.profileDetails;
    });
    var updateSmtf = function () { return __awaiter(void 0, void 0, void 0, function () {
        var empCode, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, accountDetails.getSalesEmployeeCode()];
                case 1:
                    empCode = _a.sent();
                    return [4 /*yield*/, di.clients.postPlatformReactivationLink({
                            acCode: selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.accountCode,
                            status: consentData.data,
                            empCode: empCode,
                        })];
                case 2:
                    response = _a.sent();
                    (response === null || response === void 0 ? void 0 : response.data) && alert(response === null || response === void 0 ? void 0 : response.data);
                    return [2 /*return*/];
            }
        });
    }); };
    var getBseRequest = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, di.clients.getPlatformBSERequest({
                        Accode: selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.accountCode,
                    })];
                case 1:
                    response = _a.sent();
                    setBseRequestData(response === null || response === void 0 ? void 0 : response.data);
                    return [2 /*return*/];
            }
        });
    }); };
    var updateSMTFFLAG = function (flag) {
        di.clients
            .getPlatformSMTFAcceptReject({ Accode: selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.accountCode })
            .then(function (valSMTF) {
            if (valSMTF.data === "0") {
                alert("MTF consent cannot be accepted for the user. The user is either (1) Employee or (2) Dormant or (3) LAS_MTF active (4) NON POA.");
            }
            else if (valSMTF.data === "1") {
                di.clients
                    .updatePlatformSMTFReq({
                    acCode: selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.accountCode,
                    flag: flag,
                })
                    .then(function (update) {
                    if (update.data == "1") {
                        alert("Accepted");
                    }
                    else if (update.data == "0") {
                        alert("Rejected");
                    }
                    else {
                        alert("Data not saved");
                    }
                });
            }
        });
    };
    var getSampleFile = function () {
        di.clients
            .getMandateSampleFile()
            .then(function (sample) { return setSampleFile(sample.data); });
    };
    var getPlatformFnoDetails = function (flag) {
        setShowFnoLoader(true);
        var req = {
            accountCode: selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.accountCode,
            flag: flag,
            source: "SJ",
        };
        di.clients
            .getFnoConsentDetails(req)
            .then(function (resp) {
            if (resp.process_flg !== null &&
                resp.process_flg !== undefined &&
                resp.process_flg === 1) {
                setShowErrorMsg(false);
                setShowFnoDetailsSuccess(true);
                setShowFnoDetailsSuccessMsg(resp.remarks);
                setShowFnoLoader(false);
            }
            else {
                setShowErrorMsg(true);
                setShowFnoDetailsSuccess(true);
                setShowFnoDetailsSuccessMsg(resp.remarks);
                setShowFnoLoader(false);
            }
            console.log(resp.remarks);
        })
            .catch(function (eror) {
            setShowFnoLoader(false);
            setShowErrorMsg(true);
            setShowFnoDetailsSuccess(true);
            setShowFnoDetailsSuccessMsg("Something get wrong.Please Try sometime later.");
            console.log("Error at Platform Fno Details......");
        });
    };
    var bseMFConsetRequest = function () {
        di.clients
            .postPlatformBSERequestAccept({
            acCode: selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.accountCode,
            userId: userData === null || userData === void 0 ? void 0 : userData.userId.toString(),
            ip: "",
        })
            .then(function (data) { return alert(data.data); })
            .catch(function (error) { return alert(error); });
    };
    function getConsentData() {
        // setLoader(true);
        di.clients
            .getConsentDetailsData({
            acCode: selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.accountCode,
        })
            .then(function (resp) {
            setConsentData(resp);
        });
    }
    React.useEffect(function () {
        getSampleFile();
    }, []);
    React.useEffect(function () {
        if (selectedAccount && (selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.accountCode)) {
            getBseRequest();
            getConsentData();
        }
    }, [selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.accountCode]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "relationship-head-block mx-0 px-0" },
            React.createElement(Col, { className: "DMSanBold_18_700 txt_blackOne1 px-0" }, "Consent & Mandate")),
        React.createElement("div", { className: "generic-table salestableParentClass scrollbar-table consent-table" },
            React.createElement("table", { className: "salestableclass" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null, "Product"),
                        React.createElement("th", null, "Status"),
                        React.createElement("th", null, "Consent"),
                        React.createElement("th", null, "Mandate"),
                        React.createElement("th", null, "Details"))),
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null, "SLBM"),
                        React.createElement("td", null, props.data.slbm),
                        React.createElement("td", null,
                            React.createElement("div", { className: "consent-block" }, "-")),
                        React.createElement("td", null,
                            React.createElement("div", { className: "consent-block mandateblock" }, "-")),
                        React.createElement("td", null,
                            React.createElement("div", { className: "request-block" }, "-"))),
                    React.createElement("tr", null,
                        React.createElement("td", null, "SMTF"),
                        React.createElement("td", null, props.data.smtF_Status),
                        React.createElement("td", null,
                            React.createElement("div", { className: "consent-block" },
                                props.data.smtF_Consent === "Accepted" && (React.createElement(React.Fragment, null,
                                    "Accepted on ",
                                    props.data.smtF_Date)),
                                !(props.data.smtF_Consent === "Accepted" ||
                                    props.data.smtF_Consent === "Rejected") && (React.createElement("div", { className: "request-block" },
                                    React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Accept", onClick: function () {
                                            updateSMTFFLAG("Accept");
                                        } }),
                                    React.createElement("span", { className: "mgl-10" },
                                        React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Reject", onClick: function () {
                                                updateSMTFFLAG("Reject");
                                            } })))),
                                ((_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.smtF_Consent) === "Rejected" && (React.createElement(React.Fragment, null,
                                    React.createElement("div", { className: "request-block" }, (_b = props === null || props === void 0 ? void 0 : props.data) === null || _b === void 0 ? void 0 :
                                        _b.smtF_Consent,
                                        React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Accept", onClick: function () {
                                                updateSMTFFLAG("Accept");
                                            } })))))),
                        React.createElement("td", null,
                            React.createElement("div", { className: "consent-block mandateblock" }, "-")),
                        React.createElement("td", null,
                            React.createElement("div", { className: "request-block" },
                                React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: consentData === null || consentData === void 0 ? void 0 : consentData.data, onClick: function () { return updateSmtf(); } })))),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Lower haircut"),
                        React.createElement("td", null, props.data.fnO_Status),
                        React.createElement("td", null,
                            React.createElement("div", { className: "consent-block" },
                                React.createElement("div", { className: "request-block" },
                                    showFnoLoader && (React.createElement("div", { className: "loader-box pe-5" },
                                        React.createElement("img", { src: loaderGIF }))),
                                    ((_c = props === null || props === void 0 ? void 0 : props.data) === null || _c === void 0 ? void 0 : _c.fnO_Status) === "N" && (React.createElement("div", { className: "consent-block" },
                                        ((_d = props === null || props === void 0 ? void 0 : props.data) === null || _d === void 0 ? void 0 : _d.fnO_Request_by) !== null &&
                                            ((_e = props === null || props === void 0 ? void 0 : props.data) === null || _e === void 0 ? void 0 : _e.fnO_Request_by) !== "" &&
                                            ((_f = props === null || props === void 0 ? void 0 : props.data) === null || _f === void 0 ? void 0 : _f.fnO_Request_by) !== "NA" &&
                                            ((_g = props === null || props === void 0 ? void 0 : props.data) === null || _g === void 0 ? void 0 : _g.fnO_Request_by) !== undefined && (React.createElement(React.Fragment, null,
                                            "Deactivated by ", (_h = props === null || props === void 0 ? void 0 : props.data) === null || _h === void 0 ? void 0 :
                                            _h.fnO_Request_by,
                                            " on",
                                            " ",
                                            ((_j = props === null || props === void 0 ? void 0 : props.data) === null || _j === void 0 ? void 0 : _j.fnO_Date) !== "" &&
                                                ((_k = props === null || props === void 0 ? void 0 : props.data) === null || _k === void 0 ? void 0 : _k.fnO_Date) !== null &&
                                                ((_l = props === null || props === void 0 ? void 0 : props.data) === null || _l === void 0 ? void 0 : _l.fnO_Date) !== undefined
                                                ? (_m = props === null || props === void 0 ? void 0 : props.data) === null || _m === void 0 ? void 0 : _m.fnO_Date
                                                : "")),
                                        React.createElement("div", { className: "request-block" },
                                            React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Activate", onClick: function () {
                                                    getPlatformFnoDetails(1);
                                                    // updateSMTFFLAG("");
                                                } })))),
                                    ((_o = props === null || props === void 0 ? void 0 : props.data) === null || _o === void 0 ? void 0 : _o.fnO_Status) === "Y" && (React.createElement(React.Fragment, null,
                                        React.createElement("div", { className: "consent-block" },
                                            ((_p = props === null || props === void 0 ? void 0 : props.data) === null || _p === void 0 ? void 0 : _p.fnO_Request_by) !== null &&
                                                ((_q = props === null || props === void 0 ? void 0 : props.data) === null || _q === void 0 ? void 0 : _q.fnO_Request_by) !== "" &&
                                                ((_r = props === null || props === void 0 ? void 0 : props.data) === null || _r === void 0 ? void 0 : _r.fnO_Request_by) !== "NA" &&
                                                ((_s = props === null || props === void 0 ? void 0 : props.data) === null || _s === void 0 ? void 0 : _s.fnO_Request_by) !== undefined && (React.createElement(React.Fragment, null,
                                                "Activated by ", (_t = props === null || props === void 0 ? void 0 : props.data) === null || _t === void 0 ? void 0 :
                                                _t.fnO_Request_by,
                                                " on",
                                                " ",
                                                ((_u = props === null || props === void 0 ? void 0 : props.data) === null || _u === void 0 ? void 0 : _u.fnO_Date) !== "" &&
                                                    ((_v = props === null || props === void 0 ? void 0 : props.data) === null || _v === void 0 ? void 0 : _v.fnO_Date) !== null &&
                                                    ((_w = props === null || props === void 0 ? void 0 : props.data) === null || _w === void 0 ? void 0 : _w.fnO_Date) !== undefined
                                                    ? (_x = props === null || props === void 0 ? void 0 : props.data) === null || _x === void 0 ? void 0 : _x.fnO_Date
                                                    : "")),
                                            React.createElement("span", { className: "request-block mgl-10" },
                                                React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Deactivate", onClick: function () {
                                                        getPlatformFnoDetails(2);
                                                        //  updateSMTFFLAG("Reject");
                                                    } })))))))),
                        React.createElement("td", null,
                            React.createElement("div", { className: "consent-block mandateblock" }, "-")),
                        React.createElement("td", null,
                            React.createElement("div", { className: "request-block" }, "-")))))),
        React.createElement(GenericSidebar, { delay: 10, parentClassname: "leadlog-sidebar", header: React.createElement(Row, { className: "m-0" },
                React.createElement("span", { className: "txt_blackOne1 leadlog-headspan DMSans_16_500" }, "BSEMF Consent Upload")), body: React.createElement("div", { className: "DMSanN_16_400 txt_blackOne1 content-body consent-fileupload-section overscroll-main" },
                React.createElement(Row, { className: "px-0 mx-0" },
                    React.createElement(Row, { className: "mx-0 download-text taRight" },
                        React.createElement(Col, { className: "px-0 txt-secondarynavy download-icon-block" },
                            React.createElement("a", { className: "d-flex align-items-center", download: "samplefile.csv", href: "data:text/csv;charset=utf-8,".concat(sampleFile) },
                                React.createElement("img", { src: downloadimg, alt: "download" }),
                                React.createElement("span", { className: "EncodeSans_14_500 ms-2 txt-midnight-blue" }, "Download Sample File")))),
                    React.createElement(Row, { className: "px-0 mx-0" },
                        React.createElement("div", { className: "d-feed-drag" },
                            React.createElement(FileUploadSection, { reset: resetFileUpload, disableCross: false, fileType: ["csv"], acceptFileType: ".csv", onSubmit: function (data) {
                                    var _a;
                                    if (data.base64Data == "") {
                                        setFileBase64(undefined);
                                    }
                                    else {
                                        setFileBase64((_a = data.base64Data) === null || _a === void 0 ? void 0 : _a.split(",")[1]);
                                    }
                                } }))),
                    React.createElement(EdButton, { className: "mt-3", btnTyp: "midnight-blue", value: "Upload", onClick: function () {
                            if (fileBase64) {
                                di.clients
                                    .postPlatformBSEUpload({
                                    Accode: selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.accountCode,
                                    MfConsentFile: fileBase64,
                                })
                                    .then(function (uploadData) {
                                    setUpload(false);
                                    alert("Successfully Upload");
                                })
                                    .catch(function (err) {
                                    return alert("Something went wrong.Please try again later");
                                });
                            }
                        } }))), footer: "", openKey: upload, arrowClose: true, setOpenKey: setUpload }),
        React.createElement("div", { className: "modal-fullwidth" },
            React.createElement(EdModal, { show: mandate, setShow: setMandate, showFooter: false, children: React.createElement(MandatePopup, { setledgershow: setMandate, dpname: selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.clientName, AccCode: selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.accountCode, userID: (_y = userData === null || userData === void 0 ? void 0 : userData.userId) === null || _y === void 0 ? void 0 : _y.toString() }), modalTitle: "", title: "" }),
            " "),
        React.createElement("div", { className: "modal-fullwidth" },
            React.createElement(EdModal, { show: detailMandate, setShow: setdetailMandate, showFooter: false, children: React.createElement(DetailMandatesPop, { setMandatesShow: setdetailMandate, dpname: selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.clientName, AccCode: selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.accountCode }), modalTitle: "", title: "" })),
        React.createElement(EdModal, { show: bseRequest, setShow: setBseRequest, showFooter: false, modalTitle: "sales-client commonmodal bse-star", title: "BSE Star Mutual Fund Consent", children: React.createElement(React.Fragment, null,
                React.createElement("div", { className: "DMSanN_16_400 txt_blackOne1 line-130" }, bseRequestData),
                React.createElement("div", { className: "d-flex justify-content-center pt-4" },
                    React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Accept", className: "request-accept", onClick: function () { return bseMFConsetRequest(); } }))) }),
        React.createElement(SalesToasts, { parentClass: "lead-create-toast", show: showFnoDetailsSuccess, setShow: setShowFnoDetailsSuccess, isError: showErrorMsg, position: "middle-center", message: React.createElement("span", { dangerouslySetInnerHTML: { __html: showFnoDetailsSuccessMsg } }) })));
};
export default ConsentMandate;
